import { consoleRequest } from '@/console/api/http'
import { RepublishRequest, RepublishResponse } from '@/console/api/types'

/**
 * LOGISPRD-13362 — MASS 반품 정산 재발행 API(핸드오프 §4.6). 인가는 `hasAuthority('MOMS_ENG')`
 * (11517, moms-be PR #3988 — 그 전엔 MASTER 라 이 콘솔에서 뺐었다).
 * 규약 B — 성공은 raw DTO(`RepublishResponse`), 실패만 `ApiResponseV2`(`toPanelError` 가 읽는다).
 *
 * 입력 검증(≤300건·사유 ≤500자·제어문자 불가)과 결과 집계는 순수 모듈 `tabs/mass/republish.ts` 가
 * 맡는다 — 이 파일은 요청을 그대로 실어 보내고 응답을 그대로 반환할 뿐이다. 서버가 클레임번호
 * 중복을 검사하지 않는 것은 화면 확인 다이얼로그 문구가 맡는다. 재시도는 없다(비멱등).
 */
const BASE = '/api/v1/settlement/return-inbound/republish'

export const requestRepublish = (request: RepublishRequest): Promise<RepublishResponse> =>
  consoleRequest.post<RepublishResponse, RepublishRequest>(BASE, request)
